import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";

import ICInput from "../form/input";

const RecordsColumnsSearchByFilter = props => {
  let colInputInterval = useRef();

  const [recordsLimit, setRecordsLimit] = useState("10");
  const [textSearch, setTextSearch] = useState("");
  const [searchFilterList] = useState(props.searchFilterList);
  const [searchFilter, setSearchFilter] = useState("");

  // restore previous record limit
  useEffect(() => {
    setRecordsLimit(props.recordLimit);
    setSearchFilter(Object.keys(searchFilterList)[0]);
  }, []);

  const applyFilterTypeChange = val => {
    setSearchFilter(val);
    if (textSearch.length) {
      props.setFilters({
        text: textSearch,
        limit: recordsLimit,
        filterType: val
      });
    }
  };

  const applyRecordsFilter = val => {
    setRecordsLimit(val);
    props.setFilters({
      text: textSearch,
      limit: val,
      filterType: searchFilter
    });
  };

  const handleInputChange = val => {
    // here this timeout logic is applied to tackle user input stopped so that we only call function when the user have stopped typing
    clearTimeout(colInputInterval.current);
    setTextSearch(val);

    colInputInterval.current = setTimeout(() => {
      props.setFilters({
        text: val,
        limit: recordsLimit,
        filterType: searchFilter
      });
    }, 1000);
  };

  return (
    <div className="d-flex flex-row justify-content-between flex-wrap">
      <div className="d-flex flex-row align-items-center">
        <span>Records per page:</span>
        <TextField
          style={{ width: "75px" }}
          className="ml-2"
          select
          value={recordsLimit}
          SelectProps={{
            native: true
          }}
          onChange={e => applyRecordsFilter(e.target.value)}
        >
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
          {/*<option value="150">150</option>
          
            {!props.disbleAll && <option value={props.totalRecords}>All</option>}
          */}
        </TextField>
      </div>
      {!props.disableSearchText && (
        <div className="d-flex flex-row align-items-center">
          <span>Search by:</span>
          <TextField
            select
            SelectProps={{
              native: true
            }}
            onChange={e => applyFilterTypeChange(e.target.value)}
          >
            {Object.keys(searchFilterList).map((key, index) => (
              <option key={key} value={key}>
                {searchFilterList[key]}
              </option>
            ))}
            {/* <option value="1">Filter by Responsible</option>
            <option value="2">Filter by Status</option> */}
          </TextField>
          <ICInput
            name="searchColumnsInput"
            className="ml-2 search-columns-input"
            type="text"
            value={textSearch}
            onChange={e => handleInputChange(e.target.value)}
          />
        </div>
      )}
    </div>
  );
};

export default RecordsColumnsSearchByFilter;

RecordsColumnsSearchByFilter.defaultProps = {
  recordLimit: 10,
  totalRecords: 10,
  disbleAll: false,
  disableSearchText: false
};

RecordsColumnsSearchByFilter.prototype = {
  recordLimit: PropTypes.string,
  totalRecords: PropTypes.number.isRequired,
  setFilters: PropTypes.func.isRequired,
  disbleAll: PropTypes.bool, // diable all data at once
  disableSearchText: PropTypes.bool, //disable the search text field
  searchFilterList: PropTypes.object
};
